<template>
  <a-card :bordered="false" title="申请退款">
    <a-form-model :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
      <a-form-model-item label="类型：">{{ detail.proCatalogStr }}</a-form-model-item>
      <a-form-model-item label="订单号：">{{ orderId }}</a-form-model-item>
      <div class="m-title">商品信息</div>
      <a-form-model-item :label="detail.proCatalog == 2 ? '酒店名称：' : '商品名称：'">
        <span>{{ detail.proName }}</span>
      </a-form-model-item>
      <template v-if="detail.proCatalog == 2">
        <a-form-model-item label="房型：">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item label="价格计划：">{{ detail.ratePlanName }}</a-form-model-item>
        <a-form-model-item label="间数：">{{ detail.roomSize }}</a-form-model-item>
        <a-form-model-item label="入住日期：">{{ detail.checkInDate }}</a-form-model-item>
        <a-form-model-item label="离店日期：">{{ detail.departureDate }}</a-form-model-item>
      </template>
      <template v-else>
        <a-form-model-item v-if="detail.proCatalog == 1" label="票型：">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item v-if="detail.proCatalog == 83" label="套餐：">{{ detail.optionName }}</a-form-model-item>
        <a-form-model-item label="数量：">{{ detail.roomSize }}</a-form-model-item>
        <a-form-model-item v-if="detail.proCatalog == 1 || detail.proCatalog == 83" label="出游日期："
        >{{ detail.checkInDate }}
        </a-form-model-item>
      </template>

      <a-form-model-item label="结算金额：">￥{{ detail.orderAmount }}</a-form-model-item>
      <div class="m-title">联系人</div>
      <a-form-model-item label="姓名：">{{ detail.contactName }}</a-form-model-item>
      <a-form-model-item label="联系电话：">{{ detail.contactPhone }}</a-form-model-item>
      <template v-if="detail.proCatalog == 2">
        <div class="m-title">入住人</div>
        <a-form-model-item v-for="(item, index) in detail.travellersVoList" :key="index" :label="getLiveName(index)"
        >{{ item.travellersName }}
        </a-form-model-item>
      </template>
      <template v-else>
        <div class="m-title">出游人</div>
        <a-form-model-item
          v-for="(item, index) in detail.travellersVoList"
          :label="getTravellerName(index)"
          :key="index"
        >
          <span>
            <div class="detail-list">{{ item.travellersName }}</div>
            <div class="detail-list">{{ item.cardTypeStr }}</div>
            <div class="detail-list">{{ item.cardNo }}</div>
          </span>
        </a-form-model-item>
      </template>
      <a-form-model-item label="申请退款金额：">
        <a-input style="width: 400px" v-model="refundAmount"></a-input>
      </a-form-model-item>
      <a-form-model-item label="退款原因：">
        <a-textarea style="width: 400px" v-model="refundRemark" :rows="2"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" style="width: 100px;margin-right:20px;" @click="confirmEvent">确认</a-button>
        <a-button type="primary" style="width: 100px;" @click="cancelEvent">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
export default {
  name: 'RefundRequest',
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      merchantName: this.$store.getters.userInfo.merchantName,
      detail: '',
      orderId: '',
      refundAmount: undefined,
      refundRemark: undefined
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
  },
  mounted() {
    this.orderId = this.$route.query.orderId
    this.getOrderDetails(this.orderId)
  },
  methods: {
    getOrderDetails(orderId) {
      const url = 'order/getOrderDetails/' + orderId
      this.getHttpServices()
        .getResourceService()
        .post(url)
        .then(res => {
          this.detail = res
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    getLiveName(index) {
      return '入住人' + (index + 1) + '：'
    },
    getTravellerName(index) {
      return '出游人' + (index + 1) + '：'
    },
    confirmEvent() {
      if (this.refundAmount < 0) {
        this.$message.error('退款金额不能小于0')
        return
      }
      const params = {
        orderId: this.orderId,
        refundAmount: this.refundAmount,
        createName: this.merchantName,
        refundRemark: this.refundRemark
      }
      this.getHttpServices()
        .getResourceService()
        .post('order/refundApply', params)
        .then(res => {
          this.$message.success('退款申请成功')
          setTimeout(() => this.cancelEvent(), 100)
        })
        .catch(err => {
          this.$message.error('退款申请成功')
        })
    },
    cancelEvent() {
      this.$router.back(-1)
    }
  }
}
</script>
<style scoped>
.m-title {
  color: #444444;
  font-weight: bold;
  padding-bottom: 20px;
  border-bottom: 1px solid #e9e9e9;
  margin-bottom: 20px;
  margin-left: 20px;
}

.detail-list {
  margin-right: 20px;
  width: 150px;
  display: inline-block;
}
</style>
